<script setup lang="ts">
interface Props {
  prevDisabled?: boolean;
  nextDisabled?: boolean;
}

defineProps<Props>();
defineEmits(["prevClick", "nextClick", "titleClick"]);
</script>

<template>
  <div class="flex justify-between py-4">
    <button
      class="px-2 py-1 -ml-1 rounded-lg test-prev-button focus-visible-strong disabled:opacity-40"
      type="button"
      :disabled="prevDisabled"
      @click="$emit('prevClick')"
    >
      <i class="fas fa-chevron-left" />
    </button>
    <button
      class="text-neutral1000 font-semibold text-lg px-1 rounded-lg test-set-view-type focus-visible-strong"
      @click="$emit('titleClick')"
    >
      <slot></slot>
    </button>
    <button
      class="px-2 py-1 -mr-1 rounded-lg test-next-button focus-visible-strong disabled:opacity-40"
      type="button"
      :disabled="nextDisabled"
      @click="$emit('nextClick')"
    >
      <i class="fas fa-chevron-right" />
    </button>
  </div>
</template>
